/**
 *
 * FlashCardDetail
 *
 */

import { mapGetters } from 'vuex';

export const QuestionFontSizeMixin = {
  name: 'QuestionFontSizeMixin',

  computed: {
    ...mapGetters({
      userInfo: 'userInfo',
    }),

    questionFontSize: {
      get: function () {
        return this.userInfo.profile.questionFontSize;
      },
    },

    customFontSize: function () {
      let size = '14px !important';
      switch (this.questionFontSize) {
        case 1:
          size = '14px !important';
          break;
        case 2:
          size = '16px !important';
          break;
        case 3:
          size = '20px !important';
          break;
        default:
          size = '14px !important';
      }
      return size;
    },
  },
};
